// @flow

import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import type { Theme } from '../../../../../../../types';
import { SEMIBOLD } from '../../../../../../../helpers/fontWeight';
import { getInStockText } from '../../../../../../../store/configuratorSettings/selectors';

const StyledStock = styled<any, Theme>('span')`
  font-size: ${props => props.theme.configPackage.label.fontSize};
  font-weight: ${SEMIBOLD};
  background-color: ${props => props.theme.configPackage.label.backgroundColor};
  position: absolute;
  text-align: left;
  text-transform: uppercase;
  color: ${props => props.theme.configPackage.label.color};
  min-width: 8em;
  line-height: 2em;
  padding: 0.25em 1rem;
  border-radius: 0 2em 2em 0;
  left: 0;
  top: 0.875rem;
  margin-right: 1.25rem;
`;

type OwnProps = {|
  amount: ?string,
|};

type StateProps = {|
  inStock: string,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const InStock = ({ amount, inStock }: Props) => (
  Number(amount) > 0 ? (
    <StyledStock>
      {`${(amount || '1').toString()} ${inStock}`}
    </StyledStock>
  ) : null
);

const mapStateToProps = (state): StateProps => ({
  inStock: getInStockText(state),
});

export default connect<any, OwnProps, StateProps, any, any, any>(mapStateToProps)(InStock);
